var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmazonEsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1909_3206",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1909_3206)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.33333H28V0H0V5.33333Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V14.6667H0V20Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.6667H28V5.33334H0V14.6667Z",
    fill: "#FFD133"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33333 9.33333H8.66666V10H7.33333V9.33333Z",
    fill: "#FFEDB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.05902 9.36101C6.04283 9.16667 6.19619 8.99999 6.3912 8.99999H8.27547C8.47049 8.99999 8.62385 9.16666 8.60765 9.36101L8.43637 11.4164C8.39318 11.9347 7.95992 12.3333 7.43983 12.3333H7.22685C6.70676 12.3333 6.27349 11.9347 6.2303 11.4164L6.05902 9.36101Z",
    stroke: "#A41517",
    strokeWidth: 0.666667
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10H8.66667V10.6667H8L7.33333 12L6.66667 10.6667H6V10Z",
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 1.33333,
    height: 4.66667,
    rx: 0.666667,
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.33333,
    y: 8,
    width: 1.33333,
    height: 4.66667,
    rx: 0.666667,
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.73332C6 7.14422 6.47756 6.66666 7.06667 6.66666H7.6C8.1891 6.66666 8.66667 7.14422 8.66667 7.73332C8.66667 7.8806 8.54728 7.99999 8.4 7.99999H6.26667C6.11939 7.99999 6 7.8806 6 7.73332Z",
    fill: "#A41517"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonEsIcon);
export default __webpack_public_path__ + "static/media/amazon-es-icon.736b785a3220207335f53194dd7e7879.svg";
export { ForwardRef as ReactComponent };